import { useState } from "react";

const useDialogState = (initialVisible = false) => {
    const [visible, setVisible] = useState(initialVisible);
    const [selectedItem, setSelectedItem] = useState(null);

    const open = (item = null) => {
        setSelectedItem(item);
        setVisible(true);
    };

    const close = () => {
        setVisible(false);
        setSelectedItem(null);
    };

    return {
        visible,
        selectedItem,
        open,
        close,
    };
};

export default useDialogState;
